<template>
    <div class="navbar">
        <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>

        <breadcrumb class="breadcrumb-container"/>

        <div class="right-menu">
            <template v-if="device!=='mobile'">
                <el-tooltip :content="$t('personal.setting9')" effect="dark" placement="bottom" :open-delay="openDelay">
                    <information class="information right-menu-item" />
                </el-tooltip>
                <el-tooltip :content="$t('order.fill')" effect="dark" placement="bottom" :open-delay="openDelay">
                    <order-submit class="international right-menu-item"/>
                </el-tooltip>
                <el-tooltip :content="$t('navbar.screenfull')" effect="dark" placement="bottom" :open-delay="openDelay">
                    <screenfull class="screenfull right-menu-item"/>
                </el-tooltip>
                <!--
                <el-tooltip :content="$t('navbar.size.title')" effect="dark" placement="bottom" :open-delay="openDelay">
                    <size-select class="international right-menu-item"/>
                </el-tooltip>
                -->
                <lang-select class="international right-menu-item"/>
                <template v-if="tenantList.length > 1">
                    <tenant-menu class="international right-menu-item"/>
                </template>
            </template>
            <el-dropdown class="avatar-container right-menu-item">
                <div class="avatar-wrapper">
                    <img :src="avatarP"
                         :onerror="defaultAvatar" class="user-avatar">
                    <!--i class="el-icon-caret-bottom"/-->
                </div>
                <el-dropdown-menu slot="dropdown">
                    <router-link to="/personalCenter">
                        <el-dropdown-item>
                            <i class="el-icon-user"></i>{{$t('home.personalCenter')}}
                        </el-dropdown-item>
                    </router-link>
                    <el-dropdown-item v-if="isGuest" divided>
                        <span style="display:block;" @click="login"><i class="el-icon-switch-button"></i>{{ $t('login.logIn') }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-else divided>
                        <span style="display:block;" @click="logout"><i class="el-icon-switch-button"></i>{{ $t('navbar.logOut') }}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import router from '@/router'
    import Breadcrumb from '@/components/Breadcrumb'
    import Hamburger from '@/components/Hamburger'
    // import SizeSelect from '@/components/SizeSelect'
    import LangSelect from '@/components/LangSelect'
    import TenantMenu from '@/components/TenantMenu'
    import Screenfull from '@/components/Screenfull'
    import Information from '@/components/Information'
    import OrderSubmit from '@/components/OrderSubmit'
    import { envInfo } from '@/constants/envInfo'

    export default {
        data() {
            return {
                // 默认头像
                defaultAvatar: 'this.src="' + require('@/assets/images/defaultAvatar.png') + '"',
                openDelay: 1000,
            }
        },
        components: {
            Breadcrumb,
            Hamburger,
            // SizeSelect,
            LangSelect,
            TenantMenu,
            Screenfull,
            Information,
            OrderSubmit
        },
        computed: {
            ...mapGetters([
                'sidebar',
                'device',
                'userAccount',
                'isGuest',
                'avatar',
                'tenantList'
            ]),
            avatarP() {
                if(this.avatar) {
                    return envInfo.bgApp.ssoPath+'/param/avatar?p='+this.avatar
                } else {
                    return envInfo.bgApp.ssoPath+'/param/avatar?u='+this.userAccount
                }
            }
        },
        methods: {
            toggleSideBar() {
                this.$store.dispatch('ToggleSideBar')
            },
            login() {
                // 跳转登录页面
                router.replace({
                    path: '/login',
                    query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
                })
            },
            logout() {
                this.$store.dispatch('LogOut').then(() => {
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .navbar {
        height: 50px;
        line-height: 50px;
        border-radius: 0px !important;

        .hamburger-container {
            line-height: 58px;
            height: 50px;
            float: left;
            padding: 0 10px;
        }

        .breadcrumb-container {
            float: left;
        }

        .errLog-container {
            display: inline-block;
            vertical-align: top;
        }

        .right-menu {
            float: right;
            height: 100%;

            &:focus {
                outline: none;
            }

            .right-menu-item {
                display: inline-block;
                margin: 0 8px;
            }

            .screenfull {
                height: 20px;
            }

            .information{
                height: 20px;
            }

            .international {
                vertical-align: top;
            }

            .theme-switch {
                vertical-align: 15px;
            }

            .avatar-container {
                height: 50px;
                margin-right: 30px;

                .avatar-wrapper {
                    margin-top: 5px;
                    position: relative;

                    .user-avatar {
                        cursor: pointer;
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                    }

                    .el-icon-caret-bottom {
                        cursor: pointer;
                        position: absolute;
                        right: -20px;
                        top: 25px;
                        font-size: 12px;
                    }
                }
            }
        }
    }
</style>
